import React, { useState } from 'react';
import { AiOutlineGift, AiOutlineHeart } from 'react-icons/ai'
import { BsCalculator } from 'react-icons/bs'
import { FaSun } from 'react-icons/fa'
import { IoIosArrowDown, IoMdArrowDropright } from 'react-icons/io'
import { GiThreeLeaves } from 'react-icons/gi'
import { NavLink } from 'react-router-dom';
import './AsideBar.css'

const AsideBar = ({ cat }) => {
    const [explore, setExpolore] = useState('')
    const innerItems = ['fish', 'dal', 'rice', 'oil', 'soaps', 'ghee', 'ready mixe']
    const items = ['Baby Care','Snacks & Spread','Health & Adult Care','Drinks & Beverage','Home Care & Cleaning','Fruits & Vegetables','Kitchen & Cooking']

    return (
        < >
            {cat ?
                <div className={`fixed top-20 md:bottom-0 bottom-20 md:-mt-2 -mt-4 width2 transition-all shadow-4xl bg-white overflow-hidden`}>
                    <div className="overflow-y-scroll h-full">
                        <div className="flex justify-center gap-2 py-2" style={{ backgroundColor: "#FF5454" }}>
                            <div className="avatar">
                                <div className={`rounded-full ${cat ? "w-24 h-24" : "w-14 h-14"}`}>
                                    <img src="http://daisyui.com/tailwind-css-component-profile-1@94w.png" alt='' />
                                </div>
                            </div>
                            <div className="flex flex-col mt-1">
                                <h6 className='text-gray-300 font-semibold'>Welcome</h6>
                                <h3 className='text-white font-semibold text-xl'>Dear Guest</h3>
                            </div>
                        </div>
                        <div className="px-2" style={{ backgroundColor: "#D2E7F2" }}>
                            <p className='text-blue-600 py-2'>Special Deals</p>
                            <div className="flex flex-col gap-y-2 justify-start">
                                <NavLink to="/offers" className='flex gap-x-2 items-center'>
                                    <AiOutlineGift className='text-md font-extralight text-red-600' />
                                    <span>Offers</span>
                                    <span className='bg-red-500 rounded-lg font-semibold text-white px-1'>124</span>
                                </NavLink>
                                <button className='flex gap-x-2 items-center'>
                                    <BsCalculator className='text-md font-extralight text-red-600' />
                                    <span>Discount</span>
                                    <span className='bg-red-500 rounded-lg font-semibold text-white px-1'>240</span>
                                </button>
                                <button className='flex gap-x-2 items-center'>
                                    <GiThreeLeaves className='text-xl font-extralight text-red-600' />
                                    <span>Hygiene</span>

                                </button>
                                <button className='flex gap-x-2 items-center'>
                                    <FaSun className='text-xl font-extralight text-red-600' />
                                    <span>Hygiene</span>

                                </button>
                                <button className='flex gap-x-2 items-center'>
                                    <AiOutlineHeart className='text-xl font-extralight text-red-600' />
                                    <span>Exclusive Collection</span>
                                </button>

                            </div>
                        </div>

                        <div className="px-2 ">
                            <p className='text-blue-600 py-2 px-3'>All Products</p>



                            {Array.from({ length: 6 }).map((_, id) =>
                                <div className="" key={id}>
                                    <div className='flex justify-between items-center mr-4' onClick={() => {
                                        if (id !== explore) {
                                            setExpolore(id)
                                        } else {
                                            setExpolore(null)
                                        }
                                    }}>
                                        <div className="flex gap-x-2 justify-center items-center"><AiOutlineHeart className='text-xl font-extralight text-red-600' />
                                            <span>{items[id]}</span></div>
                                        <IoIosArrowDown className={explore === id ? "rotate-180 transition-all duration-1500 -mr-1" : "rotate-0 transition-all duration-1500"}></IoIosArrowDown>

                                    </div>
                                    {explore === id && <ul className='ml-6'>
                                        {
                                            Array.from({ length: innerItems.length }).map((_, id) =>

                                                <li key={id} className='flex gap-x-2 items-center'><IoMdArrowDropright />{innerItems[id]}</li>)
                                        }
                                    </ul>}
                                </div>
                            )}



                        </div>

                    </div>
                </div> :
                <div className={`fixed top-20 -mt-2 width1 transition-all shadow-2xl hidden md:block ease-in-out duration-300`}>
                    <div className="overflow-y-scroll h-screen">
                        <div className="flex  justify-center gap-2 py-2" style={{ backgroundColor: "#FF5454" }}>
                            <div className="avatar">
                                <div className={`rounded-full ${cat ? "w-24 h-24" : "w-10 h-10"}`}>
                                    <img src="http://daisyui.com/tailwind-css-component-profile-1@94w.png" alt='' />
                                </div>
                            </div>

                        </div>
                        <div className="px-2" style={{ backgroundColor: "#D2E7F2" }}>

                            <div className="flex flex-col gap-y-2 justify-center items-center">
                                <NavLink to="/offers" className='flex gap-x-2 items-center'>
                                    <AiOutlineGift className='text-md font-extralight text-red-600' />

                                </NavLink>
                                <button className='flex gap-x-2 items-center'>
                                    <BsCalculator className='text-md font-extralight text-red-600' />

                                </button>
                                <button className='flex gap-x-2 items-center'>
                                    <GiThreeLeaves className='text-xl font-extralight text-red-600' />


                                </button>
                                <button className='flex gap-x-2 items-center'>
                                    <FaSun className='text-xl font-extralight text-red-600' />


                                </button>
                                <button className='flex gap-x-2 items-center'>
                                    <AiOutlineHeart className='text-xl font-extralight text-red-600' />

                                </button>

                            </div>
                        </div>

                        <div className="px-2">

                            {
                                Array.from({ length: 8 }).map((_, id) => <div key={id} className="flex flex-col  items-center hoverList cursor-pointer">

                                    <AiOutlineHeart className='text-xl font-extralight text-red-600' />

                                    <ul className='ml-6 hoverControl absolute left-4 top-50 overflow-visible bg-white text-black shadow-2xl rounded-md w-44 '>
                                        {
                                            Array.from({ length: innerItems.length }).map((_, id) =>

                                                <li key={id} className='flex gap-x-2 items-center overflow-visible px-3'><IoMdArrowDropright />{innerItems[id]}</li>)
                                        }
                                    </ul>


                                </div>)




                            }


                        </div>

                    </div>
                </div>

            }
        </>
    );
};

export default AsideBar;